"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ConfigProvider_1 = require("../providers/ConfigProvider");
const TokenServiceApiConfig_1 = __importDefault(require("../apis/TokenServiceApiConfig"));
const apiConfig = new TokenServiceApiConfig_1.default();
function useApiClient(Factory, basePathTransformer) {
    const { API_URL, API_URL_EXTENSION } = (0, ConfigProvider_1.useConfig)();
    const url = (0, react_1.useMemo)(() => { var _a; return (_a = basePathTransformer === null || basePathTransformer === void 0 ? void 0 : basePathTransformer(API_URL)) !== null && _a !== void 0 ? _a : `${API_URL}${API_URL_EXTENSION !== null && API_URL_EXTENSION !== void 0 ? API_URL_EXTENSION : ''}`; }, [API_URL, API_URL_EXTENSION, basePathTransformer]);
    const client = (0, react_1.useMemo)(() => new Factory(apiConfig, url), [API_URL, url]);
    return client;
}
exports.default = useApiClient;
